import type { IReportsApiPort } from '@reports/application/ports';
import type { BlockDataRequestDto, TableBlockViewDto } from '@reports/application/dtos';
import type { TableBlockConfig } from '@reports/domain/value-objects/blocks/TableBlockConfig';
import { mapTableBlockDataToViewDto } from '@reports/application/mappers';

/**
 * Use case to fetch table block data with column filtering and alignment
 *
 * Orchestrates fetching table data from API and transforming it according to
 * the blockConfig column definitions. Ensures that only configured columns are
 * returned in the correct order.
 *
 * @param {IReportsApiPort} apiPort - Repository port for API communication
 * @returns {Object} Use case with execute method
 *
 * @example
 * const useCase = fetchTableBlockDataUseCase(apiPort);
 * const data = await useCase.execute(request, blockConfig);
 */
export const fetchTableBlockDataUseCase = (apiPort: IReportsApiPort) => {
  const execute = async (filters: BlockDataRequestDto, blockConfig: TableBlockConfig): Promise<TableBlockViewDto> => {
    const tableBlockData = await apiPort.fetchTableBlock(filters, blockConfig.endpoint);

    const tableBlockViewDto = mapTableBlockDataToViewDto(tableBlockData, blockConfig.columnsConfig);

    return tableBlockViewDto;
  };

  return { execute };
};
